import { useMutation } from "react-query";

import type {
  BookingIntervalResponse,
  PutBookingIntervalArgs,
} from "api/services/appointment/schemas/booking_interval";
import { useApiClient } from "api/useApiClient";

export const usePutBookingInterval = () => {
  const client = useApiClient();
  return useMutation<BookingIntervalResponse, Error, PutBookingIntervalArgs>({
    mutationFn: args => client.putBookingInterval(args),
  });
};
